module.exports = __webpack_public_path__ + "assets/fonts/Novecentosanswide-Normal-webfont.woff2";